import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import TutorManagement from './components/TutorManagement';
import PayrollDashboard from './components/PayrollDashboard';
import Analytics from './components/Analytics';
import LeadTracking from './components/LeadTracking';
import ProfitShare from './components/ProfitShare';
import CompensationPlan from './components/CompensationPlan';
import Layout from './components/Layout';
import { ensureTokenValidityOrLogout } from './utils/auth';



function PrivateRoute({ children }) {
  const isValid = ensureTokenValidityOrLogout();
  return isValid ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/tutors" element={
          <PrivateRoute>
            <Layout>
              <TutorManagement />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/payroll" element={
          <PrivateRoute>
            <Layout>
              <PayrollDashboard />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/analytics" element={
          <PrivateRoute>
            <Layout>
              <Analytics />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/profit-share" element={
          <PrivateRoute>
            <Layout>
              <ProfitShare />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/compensation-plan" element={
          <PrivateRoute>
            <Layout>
              <CompensationPlan />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/leads" element={
          <PrivateRoute>
            <Layout>
              <LeadTracking />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/settings" element={
          <PrivateRoute>
            <Layout>
              <div className="p-6">
                <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
                <p className="text-gray-600 mt-2">Settings page coming soon...</p>
              </div>
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/adminpanel" element={
          <PrivateRoute>
            <Layout>
              <AdminPanel />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}